import React, { useEffect, useState, useCallback } from 'react';
import { Form, Row, Modal, Button, Space, Typography, Table } from 'antd';
import { sortByString, leaveEditForm } from 'utils';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
const { Text } = Typography;

type Props = {
  onHide: (data: any) => void;
  reback: () => void;
  items: {id:string, sku: string, upc: string, lotNumber: string, uom: string, fulfillmentReturnLineNum: number}[];
  ids: string[];
  lotEnable:boolean;
  uomEnable: boolean;
};

// eslint-disable-next-line
export default (props: Props) => {
  const { onHide, items, ids, lotEnable, uomEnable } = props;
  const [dataSource, setDataSource] = useState<Array<any>>([]);
  const [form] = Form.useForm();

  const checkValid = useCallback(()=>{
    const temp:any[] = []
    // console.log('items',items)
    items.map(i => {
      if(ids.includes(i.id)){
        temp.push({
          ...i,
          isValid: true
        })
      } else {
        temp.push({
          ...i,
          isValid: false
        })
      }
      return true;
    })
    setDataSource([...temp])
  },[items, ids])

  useEffect(()=>{
    checkValid()
  },[checkValid])


  /**
   * handle submit event
   */
  const handleSubmit = useCallback(async () => {
    onHide(dataSource.filter(i=> i.isValid));
  }, [dataSource, onHide]);
  /**
   * handle cancel event
   */
  const handleCancel = useCallback(async () => {
    const cancel = await leaveEditForm({}, form);
    if (cancel) {
      onHide('');
    }
  }, [onHide, form]);
  const getColumns = useCallback(()=>{
    const cls =[
      {
        title: 'SKU',
        dataIndex: 'sku',
        render: (value: any, record: any) => {
          if (record.isValid) {
            return (<Text 
              style={{width:250}}
              ellipsis={{ tooltip: value }}
              >{value}</Text>);
          } else {
            return (
              <>
                <Row>
                  <Text
                    style={{width:350}}
                    ellipsis={{ tooltip: value }}
                  >{value}</Text>
                </Row>
                <Row>
                  <Text
                    style={{
                      color: 'white',
                      backgroundColor: 'red',
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    Item is not in this RMA
                  </Text>
                </Row>
              </>
            );
          }
        },
        sorter: (a: any, b: any) => {
          return sortByString(a, b, 'sku');
        },
      },
      {
        title: 'LOT #',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
      },
      {
        title: 'UOM',
        dataIndex: 'uom',
        key: 'uom',
      },
      {
        title: 'Quantity',
        dataIndex: 'qty',
        sorter: (a: any, b: any) => {
          return sortByString(a, b, 'sku');
        },
      },
    ];
    let temp  = [...cls]
    temp = uomEnable ? [...temp] : temp.filter(i=> i.key !== 'uom')
    temp = lotEnable ? [...temp] : temp.filter(i=> i.key !== 'lotNumber')
    return [...temp]
  },[uomEnable,lotEnable])


  return (
    <Modal
      title={`Scan Result Preview`}
      centered
      visible={true}
      width={700}
      destroyOnClose={true}
      onCancel={handleCancel}
      footer={
        <Row justify="space-between">
          <Space>
            <Button onClick={()=>props.reback()} >
              Back
            </Button>
          </Space>
          <Space>
            <Button key="submit" type="primary" onClick={handleSubmit} icon={<CheckOutlined />}>
              Confirm
            </Button>
            <Button onClick={handleCancel} icon={<CloseOutlined />}>Cancel</Button>
          </Space>
        </Row>
      }
    >
        <Table
          style={{width:'100%'}}
          rowKey="sku"
          dataSource={dataSource}
          columns={getColumns()}
          pagination={false}
          size="small"
        />
    </Modal>
  );
};
